<template>
  
  <div>
    <p class='title is-1'>explore</p>
    <div class='myTile'>
      <p class='title is-3 is-6-mobile'>search for a specific user</p>
      <div class='has-text-left'>
        <p>Want to see how you did? Search for a specific user to get their infection stats.</p>
        <br>
        <form @submit.prevent="getAWS">
          <div class='columns'>
            <div class='column is-8'>
              <input class='input' type='text' v-model="searchedUser" placeholder='woodendoors7' v-on:submit="getAWS">
            </div>
            <div class='column'>
              <button type="submit" class='button is-fullwidth is-danger' :disabled="!validUser" :class="{'is-loading': searching}">search</button>
            </div>
          </div>
        </form>
        
        <p class='hint'>searches are case sensitive</p>
        <br>

        <!-- SEARCH RESULTS -->
        <div v-show="searchLoaded">
          <div v-if="searchData.infectorUser === undefined">
            <p><span class='userName'>{{ searchData.infecteeUser }}</span> was not found in the infection database. Either they did not contract the virus or you provided an invalid username.</p>
          </div>

          <div v-else> 
            <div v-if="searchData.infecteeUser === 'woodendoors7'">
              <p><span class='userName'>{{ searchData.infecteeUser }}</span> was patient zero.</p>
            </div>

            <div v-else>
              <p><span class='userName'>{{ searchData.infecteeUser }}</span> was infected on <span class='myNumber'>{{ searchData.infectionDate }}</span> at <span class='myNumber'>{{ searchData.infectionTime }}</span> by <span class='myNumber'>{{ infectionCauseText }}</span> from <span class='userName'>{{ searchData.infectorUser }}</span>.</p>                    
            </div>
          
            <br>
            <p><span class='userName'>{{ searchData.infecteeUser }}</span> spread the virus to <span class='myNumber'>{{ searchData.directInfections }}</span> other users and was responsible for a chain of <span class='myNumber'>{{ searchData.chainInfections }}</span> total infections.</p>

          </div>

        </div>

      </div>
    </div>
  </div>
</template>
<script>
import firebase from "firebase/app";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyASxTVyp87QDG2_bibkiKramTZ86MZ0ayc",
  authDomain: "r-dataisbeautiful-memovirus.firebaseapp.com",
  databaseURL: "https://r-dataisbeautiful-memovirus.firebaseio.com",
  projectId: "r-dataisbeautiful-memovirus",
  storageBucket: "r-dataisbeautiful-memovirus.firebasestorage.app",
  messagingSenderId: "419429793522",
  appId: "1:419429793522:web:c6f944305dedcb20b15a6b",
  measurementId: "G-F977F329ZD"
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

const db = firebase.firestore();

export default {
  data() {
    return {
      searchedUser: null,
      searchData: {},
      searchLoaded: false,
      searching: false,
    };
  },

  computed: {
    validUser() {
      return this.searchedUser && this.searchedUser.trim().length > 0;
    },
    infectionCauseText() {
      let cause = this.searchData.infectionCause;
      return cause === "S"
        ? "commenting on an infected post"
        : cause === "C"
        ? "replying to a comment"
        : "";
    },
  },

  methods: {
    async getAWS() {
      let user = this.searchedUser.replace(/\s/g, "");

      if (!this.validUser) return;

      this.searching = true;
      this.searchLoaded = false;
      this.searchData = { infecteeUser: user };

      try {
        // Query the collection where infecteeUser field equals the searched user
        const query = db.collection("users").where("infecteeUser", "==", user);
        const querySnapshot = await query.get();

        if (querySnapshot.empty) {
          // Not found
          this.searchLoaded = true;
          this.searching = false;
          return;
        }

        // Get the first matching document (should be only one)
        const doc = querySnapshot.docs[0];
        this.searchData = doc.data();

      } catch (err) {
        console.error("Firestore lookup error:", err);
      }


      this.searchLoaded = true;
      this.searching = false;
    },
  },
};
</script>


<style>
.hint {
  opacity: .33;
  font-style:  italic;
}
</style>
